import { sortBy, indexOf } from "lodash";

const STANDARD_SIZES = [
  "XXS",
  "XS",
  "S",
  "M",
  "L",
  "XL",
  "XXL",
  "3XL",
  "4XL",
  "5XL",
  "6XL",
];

const INT_SIZES = [
  "INT-4XS",
  "INT-3XS",
  "INT-XXS",
  "INT-XS",
  "INT-S",
  "INT-M",
  "INT-L",
  "INT-XL",
  "INT-XXL",
  "INT-3XL",
  "INT-4XL",
  "INT-5XL",
];

const DOUBLE_SIZES = [
  "XXS/XS",
  "XS/S",
  "S/M",
  "M/L",
  "L/XL",
  "XL/XXL",
  "XXL/3XL",
  "3XL/4XL",
  "4XL/5XL",
  "5XL/6XL",
];

const SIZES = [
  ...STANDARD_SIZES,
  ...INT_SIZES,
  ...DOUBLE_SIZES,
];

function sortSizes(sizesArray) {
  if (sizesArray && sizesArray.length === 0) return null;

  if (SIZES.includes(sizesArray[1])) {
    return sortBy(sizesArray, (el) => indexOf(SIZES, el));
  }
  return sizesArray.sort();
}

export default sortSizes;
